<template>
  <div v-click-outside="close" class="suggestion__wrapper">
    <van-field
      name="address"
      v-bind="[$props, $attrs]"
      :right-icon="rightIcon"
      :rules="computedRules"
      @input="handleInput"
      @blur="handleBlur"
      @focus="handleFocus"
      @click-right-icon="handleClear"
      id="detailedAddressInput"
    />
    <div v-if="suggestionVisible" class="suggestion">
      <div
        v-for="(item, idx) in suggestions"
        :key="idx"
        class="suggestion-item van-hairline--bottom"
        @click="handleClickItem(item)"
      >
        <span>{{ item.title }}</span>
        <span>{{ item.address }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
export default {
  name: 'Suggestion',
  inheritAttrs: false,
  props: {
    value: String,
    rules: {
      default: () => []
    },

    // 是否在输入框 focus 时显示建议列表
    triggerOnFocus: {
      type: Boolean,
      default: false
    },
    debounce: {
      type: Number,
      default: 300
    },
    fetchSuggestions: Function
  },
  data() {
    return {
      message: '',
      activated: false,
      suggestions: [],
      loading: false,
      highlightedIndex: -1,
      suggestionDisabled: false
    }
  },

  computed: {
    computedRules() {
      const vm = this
      const { message, validator } = vm
      const defaultRules = [
        {
          required: true,
          message: '请填写详细地址',
          trigger: 'onBlur'
        },
        { validator, message, trigger: 'onBlur' }
      ]
      return vm.rules.length > 0 ? vm.rules : defaultRules
    },
    suggestionVisible() {
      const suggestions = this.suggestions
      const isValidData = Array.isArray(suggestions) && suggestions.length > 0
      return (isValidData || this.loading) && this.activated
    },

    rightIcon() {
      return this.value ? 'close' : ''
    }
  },

  mounted() {
    const vm = this
    vm.debouncedGetData = debounce(vm.getData, vm.debounce)
  },

  methods: {
    validator(val) {
      let _res = true
      if (val.length >= 6) {
        this.message = '不能为纯数字、纯字母、没有文字的数字字母组合'
        if (/^[0-9]+$/.test(val)) {
          _res = false
        } else if (/^[0-9a-zA-Z]*$/g.test(val)) {
          _res = false
        } else if (/^[a-z]*$/g.test(val)) {
          _res = false
        } else {
          _res = true
        }
      } else {
        this.message = '最少填写六个字'
        _res = false
      }
      return _res
    },

    getData(queryString) {
      if (this.suggestionDisabled) {
        return
      }
      this.loading = true
      this.fetchSuggestions(queryString, (suggestions) => {
        this.loading = false
        if (this.suggestionDisabled) {
          return
        }
        if (Array.isArray(suggestions)) {
          this.suggestions = suggestions
          this.highlightedIndex = this.highlightFirstItem ? 0 : -1
        } else {
          console.error(
            '[Element Error][Autocomplete]autocomplete suggestions must be an array'
          )
        }
      })
    },

    handleFocus(event) {
      // 组件当前激活
      this.activated = true
      this.$emit('focus', event)

      // 配置是否允许 focus 就展示建议列表
      if (this.triggerOnFocus) {
        this.debouncedGetData(this.value)
      }
    },

    handleBlur(event) {
      this.$emit('blur', event)
    },

    handleClear() {
      this.$emit('input', '')
    },

    handleClickItem(item) {
      this.$emit('input', item.title)
      this.suggestions = []
    },

    handleInput(value) {
      this.$emit('input', value)
      this.suggestionDisabled = false
      if (!this.triggerOnFocus && !value) {
        this.suggestionDisabled = true
        this.suggestions = []
        return
      }
      this.debouncedGetData(value)
    },

    close() {
      this.activated = false
    }
  }
}
</script>
<style lang="scss" scoped>
.suggestion__wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: $white;
  .suggestion {
    box-sizing: border-box;
    background-color: #fff;
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 150px;
    overflow: auto;
    z-index: 10;
    display: flex;
    flex-direction: column;
    .suggestion-item {
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      cursor: pointer;
      padding: 5px;
      color: #000;
      font-size: 14px;
      span:nth-child(2) {
        color: $blank;
        font-size: 10px;
      }
    }
  }
  .biLiField {
    padding: 8px 3px !important;
  }
}
</style>
